"use client";

import { MDXVideo as Video } from "@appsignal-tools/design-system";

export default function MDXVideo({ ...props }) {
  return <Video {...props} />;
}
